const Menus = [
  {
    path: "/orders",
    icon: "fa-solid fa-envelope-open-text",
    title: "Cartas de servicio",
    //, label: '8'
  },
  {
    path: "/nearby-orders",
    icon: "fa-solid fa-location-crosshairs",
    title: "Ordenes cercanas",
    //, label: '8'
  },
  {
    path: "/orders-vial?showAlert=true",
    icon: "fa-solid fa-envelope-open-text",
    title: "Varo Express",
    //, label: '8'
  },
  {
    path: "/reports",
    icon: "fa-solid fa-clipboard-check",
    title: "Reportes Grúas Varo",
    admin: true,
    children: [
      { path: "/reports/orders-payments-invoices", title: "Servicios realizados" },
      { path: "/reports/orders-payments", title: "Pagos" },
      { path: "/reports/orders-invoices", title: "Facturas" },
      { path: "/reports/operators-salary", title: "Operadores" },
      { path: "/reports/new-operators-salary-gruas", title: "Operadores comisiones" },
      { path: "/reports/reports-by-cranes", title: "Gruas ordenes" },
      { path: "/reports/clerk-by-order", title: "Oficinistas ordenes" },
      { path: "/reports/orders-receivable", title: "Ordenes por cobrar" },
      // { path: '/reports/order-invoice', title: 'Facturas' },
      { path: "/reports/order-insurance", title: "Aseguradoras" },
      // { path: '/reports/income', title: 'Ingresos' },
      // { path: '/reports/fuel', title: 'Consumo de combustible' },
      // { path: '/reports/salaries', title: 'Auxiliar de nómina' },
      // { path: '/reports/prices', title: 'Lista de precios' },
      // {
      //   path: '/reports/crane', title: 'Grúas',
      //   children: [
      //     { path: '/reports/crane/maintenance', title: 'Servicios de mantenimiento' },
      //     { path: '/reports/crane/insurance', title: 'Seguro de grúa' },
      //     { path: '/reports/crane/permission', title: 'Tenencia y permisos' }
      //   ]
      // },
      // {
      //   path: '/reports/operators', title: 'Operadores',
      //   children: [
      //     { path: '/reports/operators/licenses', title: 'Licencias de manejo' },
      //     { path: '/reports/operators/holidays', title: 'Vacaciones' }
      //   ]
      // }
    ],
  },
{
    path: "/reports-varoExpress",
    icon: "fa-solid fa-clipboard-check",
    title: "Reportes Varo Express",
    admin: true,
    children: [
      { path: "/reports-VaroExpress/orders-payments-invoices", title: "Servicios realizados" },
      { path: "/reports-VaroExpress/orders-operators", title: "Operadores" }, 
      { path: "/reports-VaroExpress/orders-payments", title: "Pagos" },
      { path: "/reports-VaroExpress/orders-invoices", title: "Facturas" }, 
    ],
  },
  {
    path: "/catalogs",
    icon: "fa-solid fa-book",
    title: "Catálogos",
    children: [
      {
        path: "__tarifas__",
        title: "Tarifas",
        children: [
          { path: "/catalogs/localRates", title: "Locales" },
          { path: "/catalogs/foreignRates", title: "Foráneas" },
        ],
      },
      //{ path: '/catalogs/agreements', title: 'Convenios' },
      {
        path: "__aseguradoras__",
        title: "Aseguradoras",
        children: [
          { path: "/catalogs/insurers", title: "Listado de aseguradoras" },
          { path: "/catalogs/typeEvidences", title: "Tipos de Evidencias" },
        ],
      },
      {
        path: "__bancos__",
        title: "Bancos y Cuentas bancarias",
        children: [
          { path: "/catalogs/banks", title: "Bancos" },
          { path: "/catalogs/bankAccounts", title: "Cuentas bancarias" },
        ],
      },
      { path: "/catalogs/locations", title: "Ubicaciones" },
      {
        path: "/catalogs/brandsModels",
        title: "Marcas, modelos y tipos de Vehículos",
      },
      { path: "/catalogs/shieldingTypes", title: "Categorías de Blindaje" },
      { path: "/catalogs/cranes", title: "Grúas" },
      {
        path: "/catalogs/assistanceVehicles",
        title: "Vehículos de asistencia",
      },
      { path: "/catalogs/liftTrucks", title: "Montacargas" },
      //{ path: '/catalogs/headquarters', title: 'Bases' },
      //{ path: '/catalogs/customers', title: 'Clientes' },
      //{ path: '/catalogs/drivers', title: 'Operadores' },
      //{ path: '/catalogs/vehycle-types', title: 'Tipos de vehículos' },
      { path: "/catalogs/crane-types", title: "Categorías de grúas" },
      { path: "/catalogs/colors", title: "Colores" },
      { path: "/catalogs/type-services", title: "Tipos de servicio" },
      { path: "/catalogs/create-empty-orders-vial", title: "Crear órdenes Varo Express" },
    ],
  },
  {
    path: "/settings",
    icon: "fa-solid fa-screwdriver-wrench",
    title: "Configuración",
    children: [
      { path: "/settings/users", title: "Usuarios" },
      { path: "/settings/roles", title: "Roles y permisos" },
    ],
  },
];

export default Menus;

// export const accountantMenus = [
//   {
//     path: "/orders",
//     icon: "fa-solid fa-envelope-open-text",
//     title: "Cartas de servicio",
//   },
//   {
//     path: "/reports",
//     icon: "fa-solid fa-clipboard-check",
//     title: "Reportes",
//     admin: true,
//     children: [
//       { path: "/reports/orders-payments-invoices", title: "Pagos y facturas" },
//       { path: "/reports/orders-payments", title: "Pagos" },
//       { path: "/reports/order-insurance", title: "Aseguradoras" },
//     ],
//   },
// ];

// export const officinistMenus = [
//   {
//     path: "/orders",
//     icon: "fa-solid fa-envelope-open-text",
//     title: "Cartas de servicio",
//   },
//   {
//     path: "/orders-vial?showAlert=true",
//     icon: "fa-solid fa-envelope-open-text",
//     title: "Varo Express",
//   },
// ];
